import React from 'react';
import CheckIcon from '@material-ui/icons/Check';

export enum ProgressBarStep {
    INPROGRESS,
    NOTSTARTED,
    COMPLETED,
}

interface StepItemProps {
    progress: string;
    stepNameNode: JSX.Element;
    stepId?: ProgressBarStep;
}


export function ProgressBarStepItem(props: StepItemProps) {

    let className = '';

    switch (props.stepId) {
        case ProgressBarStep.COMPLETED: {
            className = 'completed';
            break;
        }
        case ProgressBarStep.INPROGRESS: {
            className = 'pending';
            break;
        }
        case ProgressBarStep.NOTSTARTED: {
            className = 'disabled';
            break;
        }
        default: {
            className = '';
        }

    }

    return (
        <div className={`generic-stepper-item ${className}`} >
            <div className={`generic-stepper-item-icon ${className}`}>
                <CheckIcon />
            </div>

            <div>
                {
                    props.stepNameNode                
                }
                <p className='generic-stepper-item-status'>{props.progress}</p>

            </div>
        </div>);
}

ProgressBarStepItem.defaultProps = {
    stepId: ProgressBarStep.NOTSTARTED,
};